<template>
    <div>
        <div class="form-row">
            <div class="form-row__col">
                <div class="label">{{ trans('users.label.users_to_be_imported') }}</div>
                <div class="value">{{usersToBeImported.length}}</div>
            </div>

            <div class="form-row__col">
                <div class="label">{{ trans('user-import.label.import-for-client') }}</div>
                <div class="value">{{client.name}}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col">
                <div class="label">{{ trans('user-import.label.needed_licenses') }}</div>
                <div class="value">{{neededLicences}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default  {
    props: {
        usersToBeImported: Array,
        client: Object,
        assignedCourses: Array,
        assignedUsergroups: Array,
    },
    computed: {
        numberOfUsers() {
            return this.usersToBeImported.filter(user => {
                return user.mapAction != 'only-update';
            }).length;
        },
        neededCourseLicences() {
            return this.assignedCourses.length * this.numberOfUsers;
        },
        neededUsergroupsLicences() {
            return this.assignedUsergroups.reduce((prev, assignedUsergroup) => {
                const numberOfcoursesInGroup = assignedUsergroup.user_group.countCourses;

                return (this.numberOfUsers *  numberOfcoursesInGroup) + prev;
            }, 0)
        },
        neededLicences() {
            return this.uniqueCoursesToBeAssigned.length * this.numberOfUsers;
        },
        coursesInAssignedCourses() {
            return this.assignedCourses.map(assignedCourse => assignedCourse.course);
        },
        coursesInAssignedUserGroups() {
            const coursesInAssignedUserGroups = [];

            this.assignedUsergroups.forEach(assignedUsergroup => {
               assignedUsergroup.user_group.courses.forEach(course => coursesInAssignedUserGroups.push(course));
            });

            return coursesInAssignedUserGroups;
        },
        // Returns an Array of course that will be assigned the course that has no duplicates
        uniqueCoursesToBeAssigned() {
            const combinedCourses = [...this.coursesInAssignedCourses, ...this.coursesInAssignedUserGroups];
            const uniqueCourses = combinedCourses.filter((course, indexOfFliterLoop) => {
                   const indexOfFirstOccourence = combinedCourses.findIndex((searchCourse) => searchCourse.id == course.id )
                   return indexOfFirstOccourence === indexOfFliterLoop;
                });

            return uniqueCourses;
        }

    }
};
</script>
